const styles = () => ({
  '& .btn-row-group': {
    '& .btn-grp-back': {
      '&:before': {
        display: 'none',
      },
      left: 0,
      margin: 0,
      padding: 0,
      position: 'relative',
      top: -183,

      width: 'auto',
    },

    display: 'flex',
  },
});

export default styles;
